import { constants } from '../../Viewer/viewModeConstants'

export const viewerConstants = {
	VIEWER_REQUEST: 'VIEWER_REQUEST',
	VIEWER_SUCCESS: 'VIEWER_SUCCESS',
	VIEWER_FAILURE: 'VIEWER_FAILURE',
	VIEWER_PASS: 'VIEWER_PASS',
	VIEWER_SHOW_BOARD: 'VIEWER_SHOW_BOARD',
	VIEWER_SHOW_AGG: 'VIEWER_SHOW_AGG',
	VIEWER_FLOP_CROSS_COMBO_DRAW_AGG: 'VIEWER_FLOP_CROSS_COMBO_DRAW_AGG',
	VIEWER_AGG_REQUEST: 'VIEWER_AGG_REQUEST',
	SET_VIEWER_AGG_BOARD_REACHED_LIMIT: 'SET_VIEWER_AGG_BOARD_REACHED_LIMIT',

	SET_BOARD_CARD: 'SET_BOARD_CARD',
	SET_ACTIVE_CARD_QUERY: 'SET_ACTIVE_CARD_QUERY',
	SET_TEMP_ACTION_STRUCT: 'SET_TEMP_ACTION_STRUCT',
	SET_REQUEST_STATE: 'SET_REQUEST_STATE',
	SET_ACTIVE_CARD_TRACE_INDEX: 'SET_ACTIVE_CARD_TRACE_INDEX',
	SET_ACTIVE_QUERY_TRACE_INDEX: 'SET_ACTIVE_QUERY_TRACE_INDEX',
	SET_ACTIVE_RANGE_STRUCT: 'SET_ACTIVE_RANGE_STRUCT',
	SET_ACTIVE_TABLE: 'SET_ACTIVE_TABLE',

	SET_VIEWER_REQUEST_QUERY: 'SET_VIEWER_REQUEST_QUERY',
	SET_IS_SHOW_ALTERNATIVE_EV: 'SET_IS_SHOW_ALTERNATIVE_EV',

	SET_ACTIVE_NEXT_NODE: 'SET_ACTIVE_NEXT_NODE',

	RESET_VIEWER_STATE: 'RESET_VIEWER_STATE',
	SET_GRAPHICS_RELATED_ELEMENTS_STATE: 'SET_GRAPHICS_RELATED_ELEMENTS_STATE',
	// FLOP AGG ACTIONS
	SET_AGGREGATED_REPORT_INITIALIZERS: 'SET_AGGREGATED_REPORT_INITIALIZERS',

	POSTFLOP_SPOTS_REQUEST: 'POSTFLOP_SPOTS_FETCHED_DATA',
	SET_POSTFLOP_SPOTS_DATA: 'SET_POSTFLOP_SPOTS_DATA',
	SET_IS_FAST_POSTFLOP_BOARD: 'SET_IS_FAST_POSTFLOP_BOARD',
	SET_FAST_POSTFLOP_QUERY: ' SET_FAST_POSTFLOP_QUERY',
	RESET_LIBRARY_SPOTID: 'RESET_LIBRARY_SPOTID',
	SET_TOGGLE_FAST_POSTFLOP_MODAL: 'SET_TOGGLE_FAST_POSTFLOP_MODAL',

	// BOARD1
	SET_BOARD_MODAL_OPEN: 'SET_BOARD_MODAL_OPEN',

	// SUNBURST
	SET_SUNBURST_QUERY: 'SET_SUNBURST_QUERY',
	SET_IS_SUNBURST_BOARD: 'SET_IS_SUNBURST_BOARD',
	SET_NEXT_SUNBURST_STREET: 'SET_NEXT_SUNBURST_STREET',
	SET_SUNBURST_HISTORY: 'SET_SUNBURST_HISTORY',

	// SET_VIEWER_LOCAL_STATE
	SET_STRATEGY_FILTERS: 'SET_STRATEGY_FILTERS',
	SET_RANGE_FILTERS: 'SET_RANGE_FILTERS',

	// OPACITY FILTERS
	SET_ONE_PLAYER_OPACITY_FILTERS: 'SET_ONE_PLAYER_OPACITY_FILTERS',
	SET_TWO_PLAYERS_OPACITY_FILTERS: 'SET_TWO_PLAYERS_OPACITY_FILTERS',
	SET_OPACITY_FILTERS_MOVE_MODE: 'SET_OPACITY_FILTERS_MOVE_MODE',
	// SET_LINE_SPF_OPACITY_FILTER: 'SET_LINE_SPF_OPACITY_FILTER',
	// SET_IS_RESET_LINE_SPF: 'SET_IS_RESET_LINE_SPF',
	// SET_SELECTED_EQUITY_LINE_SPF: 'SET_SELECTED_EQUITY_LINE_SPF',
	SET_LINE_SPF_DATA: 'SET_LINE_SPF_DATA',

	SET_SELECTED_HANDS_ONE_PLAYER: 'SET_SELECTED_HANDS_ONE_PLAYER',
	SET_SELECTED_HANDS_TWO_PLAYERS: 'SET_SELECTED_HANDS_TWO_PLAYERS',
	SET_SELECTED_ALONE_TWO_PLAYERS: 'SET_SELECTED_ALONE_TWO_PLAYERS',
	SET_SELECTED_POINTS_GRAPHIC: 'SET_SELECTED_POINTS_GRAPHIC',
	SET_SELECTED_POINTS_EV_GRAPHIC: 'SET_SELECTED_POINTS_EV_GRAPHIC',

	SET_COMBOS_FILTER_RANGE_ACTIVE_COUNT: 'SET_COMBOS_FILTER_RANGE_ACTIVE_COUNT',
	SET_DRAWS_FILTER_RANGE_ACTIVE_COUNT: 'SET_DRAWS_FILTER_RANGE_ACTIVE_COUNT',
	SET_EQ_BUCKETS_FILTER_RANGE_ACTIVE_COUNT: 'SET_EQ_BUCKETS_FILTER_RANGE_ACTIVE_COUNT',

	SET_VIEWER_VIEW_MODE: 'SET_VIEWER_VIEW_MODE',
	SET_VIEW_MODE_ONE_PLAYER: 'SET_VIEW_MODE_ONE_PLAYER',
	SET_VIEW_MODE_TWO_PLAYERS: 'SET_VIEW_MODE_TWO_PLAYERS',

	SET_MOVE_CELL_MODE_STRATEGY: 'SET_MOVE_CELL_MODE_STRATEGY',
	SET_MOVE_CELL_MODE_RANGE: 'SET_MOVE_CELL_MODE_RANGE',

	SET_VIEW_ACTIVE_TABLE_STRATEGY: 'SET_VIEW_ACTIVE_TABLE_STRATEGY',
	SET_VIEW_ACTIVE_TWO_PLAYERS_FILTERS_TAB: 'SET_VIEW_ACTIVE_TWO_PLAYERS_FILTERS_TAB',

	SET_ALL_EQ_BUCKETS: 'SET_ALL_EQ_BUCKETS',

	SET_EQ_NEW_BUCKETS: 'SET_EQ_NEW_BUCKETS',

	SET_RUNOUT_ACTION_FILTER: 'SET_RUNOUT_ACTION_FILTER',
	SET_RUNOUT_ACTION_FILTER_APPLIED: 'SET_RUNOUT_ACTION_FILTER_APPLIED',
	SET_RUNOUT_DISPLAY_MODE: 'SET_RUNOUT_DISPLAY_MODE',

	SET_VIEWER_SIZINGS: 'SET_VIEWER_SIZINGS',
	SET_TOOLTIP_SIZINGS: 'SET_TOOLTIP_SIZINGS',

	SET_COMBOS_AND_DRAWS: 'SET_COMBOS_AND_DRAWS',
	SET_TYPE_CARD_TRACE: 'SET_TYPE_CARD_TRACE',

	SET_UPDATE_ACTIONS_ORDER: 'SET_UPDATE_ACTIONS_ORDER',

	SET_MULTISTACKS: 'SET_MULTISTACKS',
	SET_MULTISTACKS_DATA: 'SET_MULTISTACKS_DATA',
	SET_IS_SELECTED_STACK: 'SET_IS_SELECTED_STACK',
	SET_COMBOS_MULTISTACK: 'SET_COMBOS_MULTISTACK',
	RESET_CACHE: 'RESET_CACHE',
	REQUEST_MULTISTACK: 'REQUEST_MULTISTACK',
	SET_SAME_COUNT_ACTIONS: 'SET_SAME_COUNT_ACTIONS',

	SET_REPORTS_TYPE: 'SET_REPORTS_TYPE',
	SET_IS_TIMER_ACTIVE: 'SET_IS_TIMER_ACTIVE',
	SET_TIMER_COUNTER: 'SET_TIMER_COUNTER',

	CONTROL_VISIBLE_COMBOS: 'CONTROL_VISIBLE_COMBOS',
	SINGLE_EQUITY_ACTION: 'SINGLE_EQUITY_ACTION',
	SINGLE_EQUITY_TWO_PLAYERS: 'SINGLE_EQUITY_TWO_PLAYERS',

	SET_FAST_POSTFLOP_SPOT_ID: 'SET_FAST_POSTFLOP_SPOT_ID',
	TOGGLE_NAVIGATION_VISIBLE: 'TOGGLE_NAVIGATION_VISIBLE',

	SET_EQR: 'SET_EQR',

	SET_ERROR_DATA: 'SET_ERROR_DATA',
	RESET_ERROR_DATA: 'RESET_ERROR_DATA',
	HOW_IT_WORKS: 'HOW_IT_WORKS',
	SET_CURRENT_QUERY: 'SET_CURRENT_QUERY',
}

const viewerInitialState = {
	board: ['-', '-', '-', '-', '-'],
	graphicsModeElementsVisibility: {
		type: constants.REPORTS,
	},
	strategyFilters: {
		suits: ['hh', 'hd', 'hs', 'hc', 'dh', 'dd', 'ds', 'dc', 'sh', 'sd', 'ss', 'sc', 'ch', 'cd', 'cs', 'cc'],
		combos: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
		draws: [0, 1, 2, 3, 4, 5, 6, 7],
		activeActions: [],
		eqBuckets: [
			[75, 100],
			[50, 75],
			[25, 50],
			[0, 25],
		],
	},
	rangeFilters: {
		suits: ['hh', 'hd', 'hs', 'hc', 'dh', 'dd', 'ds', 'dc', 'sh', 'sd', 'ss', 'sc', 'ch', 'cd', 'cs', 'cc'],
		combos: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
		draws: [0, 1, 2, 3, 4, 5, 6, 7],
		activeActions: [],

		/**/
		eqBuckets: [
			[75, 100],
			[50, 75],
			[25, 50],
			[0, 25],
		],
	},
	allEqBuckets: [
		[75, 100],
		[50, 75],
		[25, 50],
		[0, 25],
	],
	onePlayerOpacityFilters: {
		combosOpacity: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
		drawsOpacity: [0, 1, 2, 3, 4, 5, 6, 7],
		eqBuckets: [
			[75, 100],
			[50, 75],
			[25, 50],
			[0, 25],
		],
	},
	twoPlayersOpacityFilters: {
		combosOpacity: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
		drawsOpacity: [0, 1, 2, 3, 4, 5, 6, 7],

		/**/
		eqBuckets: [
			[75, 100],
			[50, 75],
			[25, 50],
			[0, 25],
		],
	},
	// lineSPFOpacityFilters: [],
	// isResetLineSPF: false,
	// selectedEquityLineSPF: null,

	lineSPFData: {
		// opacityFilters: [],
		highLightedClusters: [],
		selectedEquity: [],
		selectedMatrixIndex: [],
		selectedClusterIndex: [],
		sortedEquities: [],
		// isHighlightClusters: false,
		isHover: false,
	},
	isShowAlternativeEV: true,

	isMoveOpacityFiltersMode: false,

	selected_hands_strategy: [],
	selected_hands_range: [],
	selected_dots: [],
	selected_ev_dots: [],

	combosFilterActive: null,
	drawsFilterActive: null,
	eqBucketsFilterActive: {
		active10: null,
		active20: null,
		active25: null,
	},

	boardAggVisible: false,
	isReachedBoardAggLimit: false,
	viewModeOnePlayer: 'strategy',
	viewModeTwoPlayers: 'range',
	viewMode: 'onePlayer',

	moveModeRange: false,
	moveModeStrategy: false,
	activeTabKeyRange: '1',
	activeTabKeyStrategy: '1',

	sizingsStructureData: null,
	trace_action_struct: [],

	runOutActionFilter: null,
	runOutActionFilterApplied: false,
	streetTypeCard: '',

	multiStacks: [],
	multiStackData: [],
	cacheAllStacks: [],
	availableStacks: {},
	isStackSelected: false,
	cellAvailableStacks: [],
	strategies: [],
	isRequestMultiStack: false,
	structureWithSameCountOfAction: [],
	reducedArrBiggestAction: [],
	calculateSizingsAllStacks: {},

	reportsType: localStorage.getItem('graphic') ?? constants.REPORTS,
	isTurn: false,
	isTimerActive: false,
	timerPercent: 100,
	timerCounter: 0,

	isCombosDrawsVisible: true,
	isCrossTableLoading: {
		flop: false,
		preflop: false,
		comboDraw: false,
		common: false,
	},

	actionEquityStruct: [],
	actionEquityStructTwoPlayers: [],
	fastPostFlopSpotId: null,

	isNavigationVisible: false,
	eqr: {
		hero: { maxEqr: 0 },
		villain: { maxEqr: 0 },
	},

	blockedReports: [],
	howItWorksData: null,
}

// reducer for viewer
export function viewer_reducer(state = viewerInitialState, action) {
	switch (action.type) {
		case viewerConstants.SET_FAST_POSTFLOP_SPOT_ID:
			return {
				...state,
				fastPostFlopSpotId: action.payload,
			}
		case viewerConstants.SET_CURRENT_QUERY:
			return {
				...state,
				currentQuery: action.payload,
			}
		case viewerConstants.TOGGLE_NAVIGATION_VISIBLE:
			return {
				...state,
				isNavigationVisible: action.payload,
			}
		case viewerConstants.SET_SELECTED_HANDS_ONE_PLAYER:
			return {
				...state,
				selected_hands_strategy: action.payload,
			}
		case viewerConstants.CONTROL_VISIBLE_COMBOS:
			return {
				...state,
				isCombosDrawsVisible: action.isCombosDrawsVisible,
			}
		case viewerConstants.SINGLE_EQUITY_ACTION:
			return {
				...state,
				actionEquityStruct: action.payload,
			}
		case viewerConstants.SINGLE_EQUITY_TWO_PLAYERS:
			return {
				...state,
				actionEquityStructTwoPlayers: action.payload,
			}
		case viewerConstants.SET_TIMER_COUNTER:
			return {
				...state,
				timerPercent: action.timerPercent,
				timerCounter: action.timerCounter,
			}
		case viewerConstants.SET_IS_TIMER_ACTIVE:
			return {
				...state,
				isTimerActive: action.payload,
			}
		case viewerConstants.SET_REPORTS_TYPE:
			return {
				...state,
				...action,
			}
		case viewerConstants.SET_SAME_COUNT_ACTIONS:
			return {
				...state,
				...action,
			}

		case viewerConstants.RESET_CACHE:
			return {
				...state,
				...action,
			}
		case viewerConstants.REQUEST_MULTISTACK:
			return {
				...state,
				isRequestMultiStack: action.payload,
			}
		case viewerConstants.SET_IS_SELECTED_STACK:
			return {
				...state,
				isStackSelected: action.payload,
			}
		case viewerConstants.SET_MULTISTACKS_DATA:
			return {
				...state,
				multiStackData: action.multiStackData,
			}

		case viewerConstants.SET_MULTISTACKS:
			return {
				...state,
				multiStacks: action.payload,
			}

		case viewerConstants.SET_TYPE_CARD_TRACE:
			return {
				...state,
				streetTypeCard: action.payload,
			}

		case viewerConstants.SET_SELECTED_HANDS_TWO_PLAYERS:
			return {
				...state,
				selected_hands_range: action.payload,
			}
		case viewerConstants.SET_SELECTED_ALONE_TWO_PLAYERS:
			return {
				...state,
				selected_alone_hands_range: action.payload,
			}
		case viewerConstants.SET_SELECTED_POINTS_GRAPHIC:
			return {
				...state,
				selected_dots: action.payload,
			}

		case viewerConstants.SET_SELECTED_POINTS_EV_GRAPHIC:
			return {
				...state,
				selected_ev_dots: action.payload,
			}

		case viewerConstants.SET_RUNOUT_DISPLAY_MODE:
			return {
				...state,
				runOutDisplayMode: action.payload,
			}

		case viewerConstants.SET_COMBOS_FILTER_RANGE_ACTIVE_COUNT:
			return {
				...state,
				combosFilterActive: action.payload,
			}

		case viewerConstants.SET_DRAWS_FILTER_RANGE_ACTIVE_COUNT:
			return {
				...state,
				drawsFilterActive: action.payload,
			}

		case viewerConstants.SET_EQ_BUCKETS_FILTER_RANGE_ACTIVE_COUNT:
			return {
				...state,
				eqBucketsFilterActive: {
					...state.eqBucketsFilterActive,
					[action.activeType]: action.activeCount,
				},
			}

		case viewerConstants.RESET_LIBRARY_SPOTID:
			return {
				...state,
				spotId: null,
			}

		case viewerConstants.SET_EQ_NEW_BUCKETS:
			return {
				...state,
				allEqBuckets: action.payload,
				rangeFilters: {
					...state.rangeFilters,
					eqBuckets: action.payload,
				},
				strategyFilters: {
					...state.strategyFilters,
					eqBuckets: action.payload,
				},
				onePlayerOpacityFilters: {
					...state.onePlayerOpacityFilters,
					eqBuckets: action.payload,
				},
				twoPlayersOpacityFilters: {
					...state.twoPlayersOpacityFilters,
					eqBuckets: action.payload,
				},
			}

		case viewerConstants.SET_VIEWER_VIEW_MODE:
			return {
				...state,
				viewMode: action.payload,
			}

		case viewerConstants.SET_VIEW_MODE_ONE_PLAYER:
			return {
				...state,
				viewModeOnePlayer: action.payload,
			}

		case viewerConstants.SET_VIEW_MODE_TWO_PLAYERS:
			return {
				...state,
				viewModeTwoPlayers: action.payload,
			}

		case viewerConstants.SET_MOVE_CELL_MODE_STRATEGY:
			return {
				...state,
				moveModeStrategy: action.payload,
			}

		case viewerConstants.SET_MOVE_CELL_MODE_RANGE:
			return {
				...state,
				moveModeRange: action.payload,
			}
		case viewerConstants.SET_VIEW_ACTIVE_TABLE_STRATEGY:
			return {
				...state,
				activeTabKeyStrategy: action.payload,
			}
		case viewerConstants.SET_VIEW_ACTIVE_TWO_PLAYERS_FILTERS_TAB:
			return {
				...state,
				activeTwoPlayersFiltersTab: action.payload,
			}

		case viewerConstants.SET_RUNOUT_ACTION_FILTER:
			return {
				...state,
				runOutActionFilter: action.payload,
			}

		case viewerConstants.SET_RUNOUT_ACTION_FILTER_APPLIED:
			return {
				...state,
				runOutActionFilterApplied: action.payload,
			}

		// disable or enable elements in graphic viewMode
		case viewerConstants.SET_GRAPHICS_RELATED_ELEMENTS_STATE:
			return {
				...state,
				graphicsModeElementsVisibility: action.payload,
			}

		// reports related entities
		case viewerConstants.SET_AGGREGATED_REPORT_INITIALIZERS:
			return {
				...state,
				reportCurrentQuery: action.payload[0],
				reportCurrentSpotId: action.payload[1],
			}

		/* SET FILTERS*/
		case viewerConstants.SET_STRATEGY_FILTERS:
			if (action.filterType !== 'filter') {
				return {
					...state,
					strategyFilters: {
						...state.strategyFilters,
						[action.filterType]: action.filterData,
					},
				}
			}

			return {
				...state,
				strategyFilters: action.filterData,
			}

		case viewerConstants.SET_RANGE_FILTERS:
			if (action.filterType !== 'filter') {
				return {
					...state,
					rangeFilters: {
						...state.rangeFilters,
						[action.filterType]: action.filterData,
					},
				}
			}

			return {
				...state,
				rangeFilters: action.filterData,
			}

		case viewerConstants.SET_EQ_OPACITY_BUCKETS:
			return {
				...state,
				opacityEqBuckets: action.payload,
			}

		/* SET OPACITY FILTERS*/
		case viewerConstants.SET_ONE_PLAYER_OPACITY_FILTERS:
			return {
				...state,
				onePlayerOpacityFilters: {
					...state.onePlayerOpacityFilters,
					[action.filterType]: action.filterData,
				},
			}

		case viewerConstants.SET_TWO_PLAYERS_OPACITY_FILTERS:
			return {
				...state,
				twoPlayersOpacityFilters: {
					...state.twoPlayersOpacityFilters,
					[action.filterType]: action.filterData,
				},
			}

		case viewerConstants.SET_OPACITY_FILTERS_MOVE_MODE:
			return {
				...state,
				isMoveOpacityFiltersMode: action.payload,
			}

		// case viewerConstants.SET_LINE_SPF_OPACITY_FILTER:
		// 	return {
		// 		...state,
		// 		lineSPFOpacityFilters: action.payload,
		// 	}
		//
		// case viewerConstants.SET_IS_RESET_LINE_SPF:
		// 	return {
		// 		...state,
		// 		isResetLineSPF: action.payload,
		// 	}

		case viewerConstants.SET_LINE_SPF_DATA:
			return {
				...state,
				lineSPFData: { ...state.lineSPFData, ...action.payload },
			}

		// case viewerConstants.SET_SELECTED_EQUITY_LINE_SPF:
		// 	return {
		// 		...state,
		// 		selectedEquityLineSPF: action.payload,
		// 	}

		case viewerConstants.SET_NEXT_SUNBURST_STREET:
			return {
				...state,
				nextSunburstStreet: action.payload,
			}

		case viewerConstants.VIEWER_AGG_REQUEST:
			return {
				...state,
				...action,
			}

		case viewerConstants.SET_IS_FAST_POSTFLOP_BOARD: {
			return {
				...state,
				isBoardFromFastSpots: action.payload,
			}
		}

		case viewerConstants.SET_IS_SUNBURST_BOARD: {
			return {
				...state,
				isBoardFromSunburst: action.payload,
			}
		}

		case viewerConstants.SET_BOARD_MODAL_OPEN: {
			return {
				...state,
				isBoardModalVisible: action.payload,
			}
		}

		case viewerConstants.SET_FAST_POSTFLOP_QUERY: {
			return {
				...state,
				fastPostFlopQuery: action.payload,
			}
		}

		case viewerConstants.SET_SUNBURST_QUERY: {
			return {
				...state,
				sunburstQuery: action.payload,
			}
		}
		case viewerConstants.SET_SUNBURST_HISTORY: {
			return {
				...state,
				sunburstHistory: action.payload,
			}
		}
		case viewerConstants.SET_TOGGLE_FAST_POSTFLOP_MODAL: {
			return {
				...state,
				isFastPostFlopModalOpen: action.payload,
			}
		}
		case viewerConstants.RESET_VIEWER_STATE:
			return viewerInitialState

		case viewerConstants.SET_ACTIVE_CARD_TRACE_INDEX:
			return {
				...state,
				activeCardTraceIndex: action.payload,
			}

		case viewerConstants.SET_ACTIVE_QUERY_TRACE_INDEX:
			return {
				...state,
				activeQueryTraceIndex: action.payload,
			}
		case viewerConstants.SET_REQUEST_STATE:
			return {
				...state,
				isRequest: action.payload,
			}

		case viewerConstants.SET_COMBOS_AND_DRAWS:
			return {
				...state,
				action_struct: action.action_struct,
				trace_action_struct: action.trace_action_struct,
				comboSet: action.comboSet,
				drawSet: action.drawSet,
				comboSetRange: action.comboSetRange,
				drawSetRange: action.drawSetRange,
			}

		case viewerConstants.SET_TEMP_ACTION_STRUCT:
			return {
				...state,
				action_struct: action.action_struct,
				isRequestMultiStack: action.isRequestMultiStack ?? state.isRequestMultiStack,
				// trace_action_struct: [...state.trace_action_struct, action.trace_action_struct],
				comboSet: action.comboSet,
				drawSet: action.drawSet,
				comboSetRange: action.comboSetRange,
				drawSetRange: action.drawSetRange,
				availableStacks: action.availableStacks || {},
				// stacks: action.stacks || [],
				allCombos: action.allCombos,
				allDraws: action.allDraws,
				cacheAllStacks: action.cacheAllStacks,
				multiStackData: action.multiStackData ?? [],
				strategies: action.strategies ?? [],
				...action,
			}
		case viewerConstants.VIEWER_REQUEST:
			return {
				...state,
				isRequest: true,
			}

		case viewerConstants.SET_BOARD_CARD:
			return {
				...state,
				board: action.payload,
			}

		case viewerConstants.SET_ACTIVE_RANGE_STRUCT:
			return {
				...state,
				action_range_struct: action.payload[0],
				activePlayer: action.payload[1],
				villainPlayer: action.payload[2],
			}

		/** To get active query request query for reports */
		case viewerConstants.SET_VIEWER_REQUEST_QUERY:
			return {
				...state,
				viewer_request_query: action.payload,
			}

		case viewerConstants.SET_IS_SHOW_ALTERNATIVE_EV:
			return {
				...state,
				isShowAlternativeEV: action.payload,
			}

		case viewerConstants.SET_ACTIVE_TABLE:
			return {
				...state,
				table: action.payload,
			}

		case viewerConstants.SET_COMBOS_MULTISTACK:
			return {
				...state,
				allCombos: action.allCombos,
				allDraws: action.allDraws,
			}

		case viewerConstants.VIEWER_SUCCESS:
			return {
				...state,
				isRequest: false,
				isRequestMultiStack: action.isRequestMultiStack,
				activePlayer: action.player,
				villainPlayer: action.villain_player,
				trace: action.trace,
				stacks: action.stacks,
				availableStacks: action.availableStacks ?? {},
				allCombos: action.allCombos,
				allDraws: action.allDraws,
				cacheAllStacks: action.cacheAllStacks ?? [],
				calculateSizingsAllStacks: action.calculateSizingsAllStacks ?? {},
				strategies: action.strategies,

				...action,
			}

		case viewerConstants.SET_ACTIVE_NEXT_NODE:
			return {
				...state,
				next_node: action.payload,
			}

		case viewerConstants.VIEWER_PASS:
			return {
				...state,
				isRequest: false,
			}

		case viewerConstants.VIEWER_FLOP_CROSS_COMBO_DRAW_AGG:
			return {
				...state,
				isAggRequest: action.isAggRequest,
				flopCrossComboDrawData: action.boardAgg,
				...action,
			}

		case viewerConstants.VIEWER_SHOW_AGG:
			return {
				...state,
				isAggRequest: action.isAggRequest,
				boardAgg: action.boardAgg,
				...action,
			}

		case viewerConstants.SET_VIEWER_AGG_BOARD_REACHED_LIMIT:
			return {
				...state,
				isReachedBoardAggLimit: action.isReachedBoardAggLimit,
			}

		case viewerConstants.POSTFLOP_SPOTS_REQUEST:
			return {
				...state,
				isPostFlopRequest: action.payload,
			}

		case viewerConstants.SET_POSTFLOP_SPOTS_DATA:
			return {
				...state,
				isPostFlopRequest: false,
				postFlopSpotsData: action.postFlopSpotsData,
			}

		case viewerConstants.SET_ACTIVE_CARD_QUERY: {
			return {
				...state,
				activeQuery: action.query,
				viewer_request_query: action.query,
			}
		}
		case viewerConstants.VIEWER_SHOW_BOARD: {
			// change trace & change next actions to flop select
			const { trace } = state
			const actions = state.next_actions
			const query = action.q
			const { i, chooseIndex, a } = action

			// next action was applied
			if (i < 0) {
				// remove the last part of query
				let z = query.split('_')
				z = z.slice(0, z.length - 1)
				const fakeQ = z.join('_')

				const t = {}
				t.actions = []
				t.next_query = []
				t.next_actions = []
				t.actions_gto_range = []

				actions.actions.forEach((a) => {
					t.actions.push(a.action)
					t.next_query.push(a.query)
					t.next_actions.push(a.nextType)
					t.actions_gto_range.push(a.gto_range)
				})
				t.type = 'action'
				t.choose = 0
				t.player = actions.player
				t.pot = actions.pot
				t.query = fakeQ

				trace.push(t)
			}

			// action from trace was made
			else {
				// remove trace data
				trace.splice(i + 1, trace.length - i)
				trace[trace.length - 1].choose = chooseIndex
			}

			return {
				...state,
				isRequest: false,
				next_actions: {
					actions: [],
					type: a,
					query,
				},
				trace,
			}
		}

		case viewerConstants.SET_VIEWER_SIZINGS:
			return {
				...state,
				sizingsStructureData: action.payload,
			}

		case viewerConstants.SET_TOOLTIP_SIZINGS:
			return {
				...state,
				tooltipSizings: action.payload,
			}

		case viewerConstants.SET_UPDATE_ACTIONS_ORDER: {
			const { trace } = action.payload

			return {
				...state,
				trace,
			}
		}
		case viewerConstants.SET_EQR: {
			const { hero, villain } = action.payload

			return {
				...state,
				eqr: {
					hero,
					villain: villain ?? state.eqr.villain,
				},
			}
		}
		case viewerConstants.SET_ERROR_DATA: {
			const result = [...state.blockedReports, action.payload]

			return {
				...state,
				isRequest: false,
				blockedReports: [...new Set(result)],
			}
		}
		case viewerConstants.RESET_ERROR_DATA: {
			return {
				...state,
				blockedReports: action.payload,
			}
		}
		case viewerConstants.HOW_IT_WORKS: {
			return {
				...state,
				howItWorksData: action.payload,
			}
		}

		default:
			return state
	}
}
